import Vue from "vue";
import Vuex from "vuex";
import snippets from "../../public/static/snippets.json";
import teamData from "../assets/json_output.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    backgroundColorsBar: [
      { cont_subcont: "1_0", color: "#dc3545" },
      { cont_subcont: "2_0", color: "#28a745" },
      { cont_subcont: "3_0", color: "" },
    ],
    teams: teamData.teams,
    contests: teamData.contestMGT,
    loading: false,
    snippets: snippets,
  },
  getters: {
    teams(state) {
      return state.teams;
    },
    contests(state) {
      return state.contests;
    },
    loading(state) {
      return state.loading;
    },
    snippets(state) {
      return state.snippets;
    },
  },
  mutations: {
    teams(state, newValue) {
      state.teams = newValue;
    },
    contests(state, newValue) {
      state.contests = newValue;
    },
    loading(state, newValue) {
      state.loading = newValue;
    },
    snippets(state, snippets) {
      state.snippets = snippets;
    },
  },
  actions: {
    fetchData({ commit }) {
      commit("loading", true);
      fetch("static/snippets.json")
        .then((response) => response.json())
        .then((data) => commit("snippets", data));

      return fetch("static/data.json")
        .then((response) => response.json())
        .then((data) => {
          commit("teams", data.teams);
          commit("contests", data.contestMGT);
          commit("loading", false);
        })
        .catch((error) => {
          console.log(error);
          commit("loading", false);
        });
    },
  },
  modules: {},
});
